'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getDisplayName = require('recompose/getDisplayName');

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ISSUE: withArgs 容易忘記加
function setWrappedDisplayName(enhancer, name) {
  var withArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // if (process.env.NODE_ENV === 'production') return enhancer

  if (withArgs) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return function (BaseComp) {
        var Comp = enhancer.apply(undefined, args)(BaseComp);
        Comp.displayName = name + '(' + (0, _getDisplayName2.default)(BaseComp) + ')';
        return Comp;
      };
    };
  }
  return function (BaseComp) {
    var Comp = enhancer(BaseComp);
    Comp.displayName = name + '(' + (0, _getDisplayName2.default)(BaseComp) + ')';
    return Comp;
  };
}

exports.default = setWrappedDisplayName;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/setWrappedDisplayName.js
// module id = 1066
// module chunks = 0